<nb-card class="no-edge-card mb-0 inventario-mandos-card">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-header class="border-bottom-0 inventario-header">
		<div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
			<div class="d-flex align-items-center gap-3">
				<nb-icon icon="keypad-outline" class="header-icon"></nb-icon>
				<h4 class="m-0 header-title">Inventario de Mandos</h4>
			</div>
			<div class="stats-container">
				<div class="stat-item">
					<span class="stat-value">{{totalMandos}}</span>
					<span class="stat-label">Total</span>
				</div>
				<div class="stat-item stat-item--asignados">
					<span class="stat-value">{{mandosAsignados}}</span>
					<span class="stat-label">Asignados</span>
				</div>
				<div class="stat-item stat-item--libres">
					<span class="stat-value">{{mandosSinAsignar}}</span>
					<span class="stat-label">Sin asignar</span>
				</div>
				<div class="stat-item stat-item--secondary stat-item--perdidos">
					<span class="stat-value">{{mandosPerdidos}}</span>
					<span class="stat-label">Perdidos</span>
				</div>
				<div class="stat-item stat-item--secondary stat-item--estropeados">
					<span class="stat-value">{{mandosEstropeados}}</span>
					<span class="stat-label">Estropeados</span>
				</div>
			</div>
			<div class="search-container">
				<nb-form-field>
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar por ID, MAC o colegio..."
						[(ngModel)]="searchTerm" (ngModelChange)="onSearch()" class="search-input">
				</nb-form-field>
			</div>
		</div>
	</nb-card-header>

	<nb-card-body class="p-0">
		<div class="table-container" *ngIf="!loading; else loadingTpl">
			<table class="inventario-table" *ngIf="filteredMandos.length > 0; else emptyTpl">
				<thead>
					<tr>
						<th (click)="sort('idMando')" class="sortable">
							ID Mando <span class="sort-icon">{{getSortIcon('idMando')}}</span>
						</th>
						<th (click)="sort('creationDate')" class="sortable">
							Fecha de compra <span class="sort-icon">{{getSortIcon('creationDate')}}</span>
						</th>
						<th (click)="sort('centerName')" class="sortable">
							Colegio <span class="sort-icon">{{getSortIcon('centerName')}}</span>
						</th>
						<th (click)="sort('fechaEntrega')" class="sortable">
							Fecha de entrega <span class="sort-icon">{{getSortIcon('fechaEntrega')}}</span>
						</th>
						<th (click)="sort('estado')" class="sortable">
							Estado <span class="sort-icon">{{getSortIcon('estado')}}</span>
						</th>
						<th (click)="sort('battery')" class="sortable">
							Batería <span class="sort-icon">{{getSortIcon('battery')}}</span>
						</th>
						<th>Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let mando of filteredMandos">
						<td class="font-weight-bold">{{mando.idMando}}</td>
						<td>{{formatDate(mando.creationDate)}}</td>
						<td>{{mando.centerName || '—'}}</td>
						<td class="fecha-entrega-cell">
							<input type="date" class="fecha-input"
								[value]="toISODate(mando.fechaEntrega)"
								(change)="cambiarFechaEntrega(mando, $event)">
						</td>
						<td>
							<select class="estado-select"
								[ngModel]="mando.estado"
								(ngModelChange)="cambiarEstado(mando, $event)"
								[style.background]="estadoColors[mando.estado]">
								<option *ngFor="let e of estadoOptions" [ngValue]="e.value">{{e.label}}</option>
							</select>
						</td>
						<td>
							<span class="battery-indicator" [ngClass]="getBatteryClass(mando.battery)">
								{{mando.battery}}%
							</span>
						</td>
						<td class="actions-cell">
							<button nbButton size="small" status="info" ghost
								nbTooltip="Ver detalle" (click)="verDetalle(mando)">
								<nb-icon icon="eye-outline"></nb-icon>
							</button>
							<button nbButton size="small" status="danger" ghost
								nbTooltip="Eliminar" (click)="eliminarMando(mando)">
								<nb-icon icon="trash-2-outline" class="icon-trash"></nb-icon>
							</button>
						</td>
					</tr>
				</tbody>
			</table>

			<ng-template #emptyTpl>
				<div class="empty-state">
					<nb-icon icon="keypad-outline" class="empty-icon"></nb-icon>
					<p>No se encontraron mandos</p>
				</div>
			</ng-template>
		</div>

		<ng-template #loadingTpl>
			<div class="loading-state">
				<nb-spinner status="primary" size="large"></nb-spinner>
			</div>
		</ng-template>
	</nb-card-body>
</nb-card>
